import { ArrowLeftOutlined } from '@ant-design/icons'
import { CampaignEmployee } from '@components/campaign-employee/CampaignEmployee'
import { CampaignEmployee as CampaignEmployeeModel } from '@models/Campaign'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import {
  CAMPAIGN_EMPLOYEE_MANAGER_URL,
  CAMPAIGN_EMPLOYEE_URL,
} from '@utils/urls'
import { Col, Flex, Row, Skeleton, Typography } from 'antd'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

const { Title, Text } = Typography

const PastCampaignsPage = () => {
  const [employeeIsLoading, setEmployeeIsLoading] = useState<boolean>(true)
  const [managerIsLoading, setManagerIsLoading] = useState<boolean>(true)
  const [campaignEmployeeData, setCampaignEmployeeData] = useState<
    CampaignEmployeeModel[] | undefined
  >(undefined)

  const [campaignManagerData, setCampaignManagerData] = useState<
    CampaignEmployeeModel[] | undefined
  >(undefined)

  useEffect(() => {
    setEmployeeIsLoading(true)
    SBAPI.FetchPaginated<CampaignEmployeeModel[]>(
      `${CAMPAIGN_EMPLOYEE_URL}/past`,
      {
        pagination: { current: 1, pageSize: 1000 },
      }
    )
      .then((data) => setCampaignEmployeeData(data.data))
      .finally(() => setEmployeeIsLoading(false))

    setManagerIsLoading(true)
    SBAPI.FetchPaginated<CampaignEmployeeModel[]>(
      `${CAMPAIGN_EMPLOYEE_MANAGER_URL}/past`,
      {
        pagination: { current: 1, pageSize: 1000 },
      }
    )
      .then((data) => setCampaignManagerData(data.data))
      .finally(() => setManagerIsLoading(false))
  }, [])

  return (
    <Flex gap={16} vertical className="container-row">
      <Link to={'/'}>
        <Text>
          <ArrowLeftOutlined /> Retour à l&apos;accueil
        </Text>
      </Link>

      <Title className="m-0" level={3}>
        Campagnes passées
      </Title>

      {/* EMPLOYEE */}
      <Title className="m-0" level={5}>
        Mes entretiens
      </Title>
      <Row gutter={[16, 16]}>
        {employeeIsLoading && (
          <Col xs={24}>
            <Skeleton active />
          </Col>
        )}
        {campaignEmployeeData &&
          campaignEmployeeData.map((campaignEmployee) => (
            <Col key={campaignEmployee.id} xs={24}>
              <CampaignEmployee.EmployeeCard
                type="full"
                campaignEmployee={campaignEmployee}
                readonly
              />
            </Col>
          ))}
      </Row>

      {/* MANAGER */}
      {campaignManagerData && campaignManagerData.length > 0 && (
        <>
          <Title className="m-0" level={5}>
            Mes équipes
          </Title>
          <Row gutter={[16, 16]}>
            {managerIsLoading && (
              <Col xs={24}>
                <Skeleton active />
              </Col>
            )}
            {campaignManagerData.map((campaignEmployee) => (
              <Col key={campaignEmployee.id} xs={24}>
                <CampaignEmployee.ManagerCard
                  readonly
                  campaignEmployee={campaignEmployee}
                />
              </Col>
            ))}
          </Row>
        </>
      )}
    </Flex>
  )
}

export default PastCampaignsPage
